import { render, staticRenderFns } from "./PxAutocompleteBanco.vue?vue&type=template&id=b641b2be"
import script from "./PxAutocompleteBanco.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports